import { render } from "./Offline.vue?vue&type=template&id=0957edd9"
import script from "./Offline.vue?vue&type=script&lang=js"
export * from "./Offline.vue?vue&type=script&lang=js"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__